import { API as FailedRecordsAPI, type IFailedRecord } from './failed-record';

export const API = {
  failedRecords: FailedRecordsAPI,
};

export type { IFailedRecord };
